import type { LucideIcon } from 'lucide-react'
import { TimePeriodToggle } from './TimePeriodToggle'
import type { TimePeriod } from '@/types/dashboard'

interface DashboardSectionHeaderProps {
  icon: LucideIcon
  title: string
  period?: TimePeriod
  onPeriodChange?: (period: TimePeriod) => void
}

export function DashboardSectionHeader({
  icon: Icon,
  title,
  period,
  onPeriodChange,
}: DashboardSectionHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-3 sm:mb-4">
      <h3 className="text-base sm:text-lg font-semibold flex items-center gap-2">
        <Icon className="h-5 w-5 text-brand-fg" />
        {title}
      </h3>
      {period && onPeriodChange && (
        <TimePeriodToggle value={period} onChange={onPeriodChange} />
      )}
    </div>
  )
}
